export class EventLogs {
  Id: number;
  TrainId: number;
  Datetime: string;
  EventType: string;
  ChemicalUsed: string;
  StartPh: string;
  EndPh: string;
  StartTemp: string;
  EndTemp: string;
  FlowRate: string;
  CirculationTime: string;
  SoakTime: string;
  Observations: string;
  CreatedAt: string;
  UpdatedAt: string;
}
